<template>
  <div class="dhn-footer"
    v-if="footerData"
  >
    <b-container>
      <div class="row ">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
            <img
              v-if="footerData.logo"
              class="mx-auto d-block mb-3"
              :src="footerData.logo"
              width="64"
              alt="DHN Logo"
            >
            <div class="text-center"><h2>{{ footerData.titel }}</h2></div>
        </div>
      </div>
      <hr class="footer-line">
      <b-row>
        <div class="col-md-3 col-sm-6 col-6 ">
          <div class="footer-widget ">
            <div
              class="footer-title"
            >
              {{ footerData.spalte_2_titel }}
            </div>
            <div
              v-if="footerData.spalte_2_text"
              v-html="normalize(footerData.spalte_2_text)"
              class="footer-text"
            />
            <ul class="list-unstyled"
              v-if="footerData.spalte_2_links"
            >
              <li
                v-for="(link, index) in footerData.spalte_2_links"
                :key="index"
              >
                <a
                  v-if="link.url"
                  :href="link.url"
                  target="_blank"
                  class="dhn-footer-link"
                >
                  {{ link.text}}
                </a>
                <b-link
                  v-if="link.url_intern"
                  router-tag="a"
                  :to="link.url_intern"
                  class="dhn-footer-link"
                >
                  {{ link.text }}
                </b-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- Spalte 3 -->
        <div class="col-md-6 col-sm-6 col-6 ">
          <div class="footer-widget ">
            <div
              class="footer-title"
            >
              {{ footerData.spalte_3_titel }}
            </div>
            <div
              v-if="footerData.spalte_3_text"
              v-html="normalize(footerData.spalte_3_text)"
              class="footer-text"
            />
            <ul class="list-unstyled"
              v-if="footerData.spalte_3_links"
            >
              <li
                v-for="(link, index) in footerData.spalte_3_links"
                :key="index"
              >
                <a
                  v-if="link.url"
                  :href="link.url"
                  target="_blank"
                  class="dhn-footer-link"
                >
                  {{ link.text}}
                </a>
                <b-link
                  v-if="link.url_intern"
                  router-tag="a"
                  :to="link.url_intern"
                  class="dhn-footer-link"
                >
                  {{ link.text }}
                </b-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- Spalte 4 -->
        <div class="col-md-3 col-sm-6 col-6 ">
          <div class="footer-widget ">
            <div
              class="footer-title"
            >
              {{ footerData.spalte_4_titel }}
            </div>
            <div
              v-if="footerData.spalte_4_text"
              v-html="normalize(footerData.spalte_4_text)"
              class="footer-text"
            />
            <ul class="list-unstyled"
              v-if="footerData.spalte_4_links"
            >
              <li
                v-for="(link, index) in footerData.spalte_4_links"
                :key="index"
              >
                <a
                  v-if="link.url"
                  :href="link.url"
                  target="_blank"
                  class="dhn-footer-link"
                >
                  {{ link.text}}
                </a>
                <b-link
                  v-if="link.url_intern"
                  router-tag="a"
                  :to="link.url_intern"
                  class="dhn-footer-link"
                >
                  {{ link.text }}
                </b-link>
              </li>
            </ul>
          </div>
        </div>
      <!-- tiny-footer -->
      </b-row>
      <b-row>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center ">
          <div class="tiny-footer">
            <div
              v-html="normalize(footerData.copyright)"
            />
          </div>
          <!-- /. tiny-footer -->
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'dhnFooter',
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapGetters({
      footerData: 'getFooterData'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
